import { createFetcher } from '../../Common';

import { getBaseUrl, ORG_PREFERRED_SLOT_ENDPOINT } from '../../constants';

class OrgPreferredSlot {
  static instance = null;

  static getInstance() {
    if (!this.instance) {
      this.instance = new OrgPreferredSlot(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.fetcher = fetcher;
    this.endpoint = ORG_PREFERRED_SLOT_ENDPOINT;
  }

  get base_url() {
    return getBaseUrl();
  }

  async get() {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }
}

export const createOrgPreferredSlot = () => OrgPreferredSlot.getInstance();
